import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyADXDnJh9A8DD0-SkXuylsjAbrxxKOcm2E",
  authDomain: "drijezie.firebaseapp.com",
  projectId: "drijezie",
  storageBucket: "drijezie.firebasestorage.app",
  messagingSenderId: "855161458817",
  appId: "1:855161458817:web:782d0fd116ecb74213fd80",
  measurementId: "G-GWXTGQQT8Y"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
